module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Choose a color","contrastMessage":"If you read without problems,<br>it\u0027s OK in contrast","btnSave":"Select color"},"es":{"title":"Escoje un color","contrastMessage":"Si puedes leer sin problema,<br>esta bien el contraste","btnSave":"Seleccionar color"}}')
  delete Component.options._Ctor
}
